class LoaderExternalInterface {
	constructor(store, base) {
		this.appLoaded = false;
		this.store = store;
		this.base = base;
	}
	getApplicationLoaded() {
		return this.appLoaded;
	}
	GetTotal() {
		return this.store.getState().exercise.items.length;
	}
	GetScore() {
		return this.store.getState().exercise.totalCorrectAnswers;
	}
	getBase() {
		return this.base;
	}
}

export default LoaderExternalInterface;
